const formatPrice = (price, lang) => {
  if (!price && price !== 0) return '';
  if (typeof price !== 'number') return price;
  const locale = lang === 'en' ? 'en-US' : 'es-AR';
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: 'ARS',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(price);
};

export const formatPriceNoTax = (price, lang) => {
  if (!price && price !== 0) return '';
  if (typeof price !== 'number') return price;
  const locale = lang === 'en' ? 'en-US' : 'es-AR';
  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: 'ARS',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(price / 1.21);
};

export default formatPrice;
